import { useEffect } from 'react';
import { Capacitor, Plugins } from '@capacitor/core';
export function useStatusBarStyle(style) {
    useEffect(function () {
        if (Capacitor.platform === 'ios') {
            Plugins.StatusBar.setStyle({ style: style });
        }
        else if (Capacitor.platform === 'android') {
            Plugins.StatusBar.setStyle({ style: style });
            Plugins.StatusBar.setOverlaysWebView({ overlay: true });
        }
    }, [style]);
}
//# sourceMappingURL=useStatusBarStyle.js.map